import React from "react";
import { useNavigate } from "react-router-dom";
import handleUserNavigation from "../components/layouts/handleNavigation";
import Iconfoundation from "../assets/Notifications.svg";
import { useTranslation } from "react-i18next";

const Notification = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <div>
            <button className="landing-page-buttons" onClick={()=>{handleUserNavigation(navigate, "/", "/admin/notification/notification-management")}}>
              <img
                    src={Iconfoundation}
                    alt="Foundation Icon"
                    width={80}
                    height={80}
                />
            </button>
            <div className="button-label">{t("notification")}</div>
        </div>
    );
};

export default Notification;
